import { Component, OnInit, output, input, inject } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentService, ApContentPipe } from '@ap/content';

import content from './submit.content.json';

/**
 * @ngdoc component
 * @name ApSubmitComponent
 */
@Component({
    selector: 'ap-submit',
    standalone: true,
    templateUrl: 'submit.component.html',
    styleUrls: ['./submit.component.scss'],
    imports: [ApButtonComponent, ApContentPipe]
})
export class ApSubmitComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - Text to show on submit button
     */
    public readonly submitText = input.required<string>();

    /**
     * Is it possible to sign?
     * Defaults to false
     */
    public readonly canSign = input(false);

    /**
     * Emits event after submit
     */
    public submitted = output<void>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    protected onClick(): void {
        if (this.canSign()) {
            this.submitted.emit();
        }
    }
}
